import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CREHANA_PLAYER_TRANSLATION_KEY } from "./constants";
export default /*#__PURE__*/_defineProperty({}, CREHANA_PLAYER_TRANSLATION_KEY, {
  ERROR_VIDEO: 'Ocorreu um erro no vídeo. Por favor, tente atualizar o seu navegador.',
  BACK_LABEL: 'Voltar',
  SEE_MORE: 'Ver mais',
  CLOSE: 'Fechar',
  // LANGUAGE LABELS
  SPANISH: 'Espanhol',
  PORTUGUESE: 'Português',
  ENGLISH: 'Inglês',
  // Controlbar
  ADD_NOTE_LABEL: 'Adicionar anotação',
  SETTINGS_LABEL: 'Configuração',
  FULLSCREEN_LABEL: 'Tela cheia',
  FULLSCREEN_DISABLE_LABEL: 'Sair da tela cheia',
  FULLSCREEN_NOT_AVAILABLE: 'Tela cheia não disponível',
  PIP_LABEL: 'Reprodutor flutuante',
  DISABLE_PIP_LABEL: 'Desativar reprodutor flutuante',
  MUTE_LABEL: 'Desativar som',
  UNMUTE_LABEL: 'Reactivar som',
  FORWARD_LABEL: 'Avançar 10 segundos',
  BACKWARD_LABEL: 'Voltar 10 segundos',
  PLAY_LABEL: 'Reproduzir',
  PAUSE_LABEL: 'Pausar',
  REPLAY_LABEL: 'Repetir',
  CC_LABEL: 'Áudio e legendas',
  // Settings
  SPEED: 'Velocidade',
  QUALITY: 'Qualidade de vídeo',
  AUTO_QUALITY: 'Automática',
  AUDIO: 'Áudio',
  SUBTITLES: 'Legendas',
  DISABLED_SUBTITLES: 'Desativados',
  BACK_TO_VIDEO: 'Voltar ao vídeo',
  AUTOPLAY: 'Reprodução automática',
  SHOW_NOTES: 'Mostrar anotações',
  // Endscreen
  ENDSCREEN_START_IN: 'começará em {{count}} segundo',
  ENDSCREEN_START_IN_plural: 'começará em {{count}} segundos',
  ENDSCREEN_WATCH_NOW: 'Começar',
  CANCEL: 'Cancelar',
  NEXT_LECTURE: 'Próxima aula',
  SKIP_VIDEO: 'Ver a próxima aula',
  // Idle screen
  IDLESCREEN_TITLE: 'Oi, você continua aí?',
  IDLESCREEN_CONTINUE: 'Ver a próxima aula',
  IDLESCREEN_GO_BACK: 'Voltar ao início do módulo',
  IDLESCREEN_IGNORE: 'Não mostrar novamente',
  // Confirmation overlay
  CONFIRMATION_TITLE_W_NAME: '{{name}}, falta pouco para terminar',
  CONFIRMATION_TITLE: 'Falta pouco para terminar',
  CONFIRMATION_DETAIL: 'Falta apenas {{minutes}} para que você complete sua aula',
  CONFIRMATION_LEAVE: 'Sair da aula',
  CONFIRMATION_CONTINUE: 'Seguir vendo a aula',
  // Quality warnings
  HD: 'HD',
  RECOMMENDED: 'recomendada',
  LOW_QUALITY_WARNING_TITLE: 'A qualidade do seu vídeo está baixa',
  LOW_QUALITY_WARNING_DESCRIPTION: 'Reduzimos a qualidade porque a conexão é lenta, as imagens podem não ficar nítidas.',
  LOW_QUALITY_WARNING_CTA: 'Ajuste a qualidade neste ícone',
  MANUAL_HIGH_QUALITY_WARNING_TITLE: 'Você melhorou a qualidade do seu vídeo!',
  MANUAL_HIGH_QUALITY_WARNING_DESCRIPTION: 'Lembre-se que se a **velocidade da sua conexão for lenta**, suas aulas podem **demorar para carregar**.',
  MANUAL_HIGH_QUALITY_WARNING_CTA: 'Você pode definir a qualidade quantas vezes quiser neste ícone',
  // Error overlay
  ERROR_TITLE: 'Estamos com dificuldades para reproduzir este vídeo',
  AI_LABEL: 'Notas com IA',
  AI_LABEL_TITLE: 'Notas de aula',
  AI_LABEL_TITLE_LONG: 'Notas de aula com IA',
  AI_SKIP_BUTTON_LABEL: 'Gerar notas',
  AI_TAG: 'Beta',
  AI_ERROR_TITLE: 'Ocorreu um erro ao gerar as notas',
  AI_ERROR_SUBTITLE: 'Por favor, tente novamente',
  AI_SUCCESS_TOAST_TITLE: 'Suas anotações foram salvas com sucesso',
  AI_SUCCESS_TOAST_SUBTITLE: 'Você as encontrará na seção de anotações dentro da sala de aula',
  AI_SUCCES_LABEL: 'Entendido',
  AI_CTA_BUTTON_SAVE: 'Salvar',
  AI_LABEL_SUGGESTED: 'Notas sugeridas',
  AI_SUCCESS_LABEL: 'Iniciar a próxima aula',
  AI_LOADING: 'Estamos gerando seu resumo de classe com inteligência artificial',
  AI_SUCCESS_TITLE: 'Você salvou todas as notas geradas',
  AI_SUCCESS_SUBTITLE: 'Você pode gerar notas novamente, se desejar',
  AI_DESCRIPTION_SHORT: 'Gerar um resumo após cada lição com a IA para reforçar seu conhecimento',
  AI_SUGGESTIONS_DESCRIPTION: 'Selecione uma ideia e, com o botão Salvar, adicione-a à sua seção de anotações, onde poderá editá-la a partir daí',
  AI_DESCRIPTION: 'Ao final de cada aula, você poderá gerar um resumo com nossa inteligência artificial para reforçar seu conhecimento',
  CUSTOM_GENERATE_AI: 'Eles são gerados por uma inteligência artificial para ajudá-lo a entender melhor suas aulas em vídeo. [Mais informações](https://ayuda.crehana.com/)',
  CUSTOM_GENERATE_AI1: 'Use as anotações como uma ferramenta de estudo, mas não como um substituto; revise as aulas primeiro.',
  CUSTOM_GENERATE_AI2: 'A versão "beta" é oferecida a um grupo limitado de usuários para feedback e aprimoramento antes do lançamento oficial.',
  AI_CTA_BUTTON: 'Gerar notas',
  AI_CTA_NEW_BUTTON: 'Gerar novas notas',
  ERROR_DESC: 'Recomendamos que você atualize seu navegador ou tente novamente mais tarde.',
  // Key names
  SPACE: 'espaço',
  ARROW_UP: 'seta para cima',
  ARROW_DOWN: 'seta para baixo',
  M: 'm',
  ARROW_LEFT: 'seta para a esquerda',
  ARROW_RIGHT: 'seta para a direita',
  F: 'f',
  A: 'a'
});